import { useState } from "react";
import { Link, Redirect } from "react-router-dom";

import { useMutation } from "@tanstack/react-query";
import {
  Flex,
  Label,
  Panel,
  Button,
  FormGroup,
  TextInput,
} from "@ubisend/pulse-components";

import { Logo } from "../../Components/Logo";
import { login } from "../../api/auth";
import { useAuth } from "../../hooks";

const Login = () => {
  const [creds, setCreds] = useState({ email: "", password: "" });

  const { authenticated, loginUser } = useAuth();

  const handleEmailChange = (e) =>
    setCreds({ ...creds, email: e.target.value });

  const handlePasswordChange = (e) =>
    setCreds({ ...creds, password: e.target.value });

  const mutation = useMutation({
    mutationFn: login,
    onSuccess: ({ data }) => {
      const { token, ...rest } = data.data;
      loginUser({ token, user: rest });
    },
  });

  const valid = Boolean(creds.email && creds.password);

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!valid) {
      return;
    }

    mutation.mutate({ email: creds.email, password: creds.password });
  };

  if (authenticated) {
    return (
      <Redirect
        to={{
          pathname: "/dashboard",
          state: {
            notification: {
              type: "success",
              message: "You have been successfully logged In.",
            },
          },
        }}
      />
    );
  }

  return (
    <Panel>
      <Flex col pad half mxAuto middle yScreen style={{ maxWidth: "25%" }}>
        <Flex middle mt>
          <Logo />
        </Flex>
        <form onSubmit={handleSubmit}>
          <FormGroup>
            <Label htmlFor="email">Email</Label>
            <Flex relative>
              <TextInput
                id="email"
                aria-label="email-input"
                placeholder="Email"
                value={creds.email}
                onChange={handleEmailChange}
              />
            </Flex>
          </FormGroup>
          <FormGroup>
            <Label htmlFor="password">Password</Label>
            <Flex relative>
              <TextInput
                id="password"
                aria-label="password-input"
                type={"password"}
                placeholder="Password"
                value={creds.password}
                onChange={handlePasswordChange}
              />
            </Flex>
          </FormGroup>
          <Flex ySpace center col>
            <Button
              variant="primary"
              fat
              mt
              middle
              disabled={!valid}
              type="submit"
              loading={mutation.isPending}
            >
              {mutation.isPending ? "Logging in" : "Log in"}
            </Button>
            <Button as={Link} to="/password/request" variant="inline">
              Forgot your password?
            </Button>
          </Flex>
        </form>
      </Flex>
    </Panel>
  );
};

Login.propTypes = {};

export default Login;
